<template>
	<div class="p-10">
		<div class="disp-flex">
			<div class="mb-20">
				<h1 class="mt-0">{{ $t('settings') }}</h1>
			</div>
		</div>
		<el-card>
			<template v-if="env === 'development'">
				<el-alert>
					<h3>For Development</h3>
					<section>
						<div class="mb-10">
							<p>Refresh token</p>
							<el-button type="primary" size="mini" @click="requestNewToken">
								Request New Token
							</el-button>
						</div>
					</section>
					<hr />
					<section>
						<p>Grapesjs</p>
						<el-button size="mini" type="primary" @click="$router.push({ name: 'grapesjs' })">Go to Grapesjs Sandbox</el-button>
					</section>
					<hr />
					<section>
						<h3>Timetravel</h3>
						<div>
							<div>
								<h5>{{ $t('currentTime') }}</h5>
								<div class="mb-10">
									{{ currentTime }}
								</div>
							</div>

							<h5>{{ $t('setNewTime') }}<sup>dev</sup></h5>
							<el-form ref="timingForm" :model="timingForm" label-position="top" :inline="true" size="mini">
								<el-form-item>
									<el-date-picker v-model="timingForm.timeStamp" format="dd-MM-yyyy HH:mm" type="datetime" :placeholder="$t('chooseTimestamp')" :picker-options="pickerOptions" />
								</el-form-item>
								<el-form-item>
									<el-button type="primary" @click="submitForm('timingForm')">
										{{ $t('confirmTimeTravel') }} <i><svg-icon icon-class="rocket-solid"/></i>
									</el-button>
								</el-form-item>
								<el-form-item>
									<el-button type="warning" @click="resetTime"
									>Reset <i><svg-icon icon-class="undo-solid"/></i>
									</el-button>
								</el-form-item>
							</el-form>
						</div>
					</section>
				</el-alert>
				<hr class="mb-20" />
			</template>
			<section>
				<div>
					<div class="mb-10">
						<h3>Force send</h3>
						Will force send: <b>{{ forceSend }}</b>
						<div class="mt-15">
							<el-button type="primary" size="mini" @click="toggleForceSend">
								Toggle force send
							</el-button>
						</div>
					</div>
				</div>
			</section>
			<hr class="mb-20" />
			<section>
				<h3>UI &amp; UX</h3>
				<div class="mb-10">{{ $t('themeColor') }}</div>
				<div>
					<theme-picker style="height: 26px;margin: -3px 8px 0 0;" @change="themeChange" />
					<el-button type="primary">test</el-button>
					<el-button type="success">test</el-button>
					<el-button type="warning">test</el-button>
					<el-button type="danger">test</el-button>
				</div>
				<div class="mb-10">{{ $t('fixedHeader') }}</div>
				<el-switch v-model="fixedHeader" class="drawer-switch" />
				<div class="mb-10">{{ $t('sidebarLogo') }}</div>
				<el-switch v-model="sidebarLogo" class="drawer-switch" />
			</section>
			<hr class="mb-20 mt-20" />
			<section>
				<json-editor ref="jsonEditor" v-model="jsonData" />
			</section>
			<hr />
			<section>
				<b>TinyMCE API Key</b> <br />
				{{ apiKey }}
				<!-- <editor
          v-model="tinymcecontent"
          api-key="apiKey"
          :init="{
            height: 500,
            menubar: false,
            plugins: [
              'print preview importcss  searchreplace autolink autosave save directionality visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help  charmap quickbars emoticons'
            ],
            toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment'
          }"
          @onDirty="isDirty = true"
        /> -->
			</section>
		</el-card>
	</div>
</template>

<script>
import JsonEditor from '@/components/JsonEditor';
import axios from 'axios';
import { mapGetters } from 'vuex';
import ThemePicker from '@/components/ThemePicker';
import cognito from '@/cognito';

export default {
	components: { JsonEditor, ThemePicker },
	data() {
		return {
			forceSend: undefined,
			tinymcecontent: '',
			isDirty: false,
			jsonData: JSON.parse('[{"test":"test"}]'),
			showBSModal: false,
			currentTime: null,
			timingForm: { timeStamp: null },
			timingFormRules: {
				timeStamp: {
					required: true,
					message: ''
				}
			},
			pickerOptions: {
				shortcuts: [
					{
						text: 'Today',
						onClick(picker) {
							picker.$emit('pick', new Date());
						}
					},
					{
						text: 'tomorrow',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() + 3600 * 1000 * 24);
							picker.$emit('pick', date);
						}
					},
					{
						text: 'nextWeek',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
							picker.$emit('pick', date);
						}
					}
				]
			}
		};
	},
	computed: {
		...mapGetters(['env', 'selectedParticipantStore', 'forceSendStore']),
		apiKey() {
			return process.env.VUE_APP_TINYMCE_API_KEY;
		},
		fixedHeader: {
			get() {
				return this.$store.state.settings.fixedHeader;
			},
			set(val) {
				this.$store.dispatch('settings/changeSetting', {
					key: 'fixedHeader',
					value: val
				});
			}
		},
		tagsView: {
			get() {
				return this.$store.state.settings.tagsView;
			},
			set(val) {
				this.$store.dispatch('settings/changeSetting', {
					key: 'tagsView',
					value: val
				});
			}
		},
		sidebarLogo: {
			get() {
				return this.$store.state.settings.sidebarLogo;
			},
			set(val) {
				this.$store.dispatch('settings/changeSetting', {
					key: 'sidebarLogo',
					value: val
				});
			}
		}
	},
	watch: {
		forceSendStore() {
			this.forceSend = this.forceSendStore;
		},
		selectedParticipantStore() {
			const timetravelURL = `${process.env.VUE_APP_TIMETRAVEL_ENDPOINT}/${this.selectedParticipantStore}`;

			axios
				.get(timetravelURL, { headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` } })
				.then(res => {
					this.currentTime = new Date(res.data.now.value.toString());
				})
				.catch(e => {
					console.log(e);
				});
		}
	},
	created() {
		if (this.selectedParticipantStore) {
			const timetravelURL = `${process.env.VUE_APP_TIMETRAVEL_ENDPOINT}/${this.selectedParticipantStore}`;

			axios
				.get(timetravelURL, { headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` } })
				.then(res => {
					this.currentTime = new Date(res.data.now.value.toString());
				})
				.catch(e => {
					console.log(e);
				});
		}
	},
	mounted() {
		this.forceSend = this.$store.getters['forceSendStore'];
	},
	methods: {
		requestNewToken() {
			cognito.refreshSession();
		},
		toggleForceSend() {
			let newVal;
			console.log(typeof this.$store.getters['forceSendStore']);
			console.log(this.$store.getters['forceSendStore']);
			if (this.$store.getters['forceSendStore'] === 'false' || this.$store.getters['forceSendStore'] === false) {
				newVal = true;
			} else if (this.$store.getters['forceSendStore'] === 'true' || this.$store.getters['forceSendStore'] === true) {
				newVal = false;
			} else {
				//
			}
			this.$store.commit('risolto/SET_FORCE_SEND', newVal);
			console.log(this.$store.getters['forceSendStore']);
		},
		handleBootstrapMOdal() {
			this.showBSModal = true;
		},
		handleClick(command) {},
		handleTest() {
			axios
				.get(process.env.VUE_APP_FE_PROXY_TEST_ENDPOINT, { headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` } })
				.then(res => {
					console.log('res van handleTest: ', res);
				})
				.catch(e => {
					console.log(e);
				});
		},
		themeChange(val) {
			this.$store.dispatch('settings/changeSetting', {
				key: 'theme',
				value: val
			});
		},
		resetTime() {
			const payload = {
				version: 'v2',
				participant: this.selectedParticipantStore
			};
			axios
				.post(process.env.VUE_APP_TIMETRAVEL_RESET, payload, { headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` } })
				.then(res => {
					this.$notify({
						title: this.$t('success'),
						message: this.$t('success'),
						type: 'success'
					});

					const timetravelURL = `${process.env.VUE_APP_TIMETRAVEL_ENDPOINT}/${this.selectedParticipantStore}`;

					axios.get(timetravelURL, { headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` } }).then(res => {
						this.currentTime = new Date(res.data.now.value.toString());
					});
				})
				.catch(e => {
					console.log(e);
				});
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					console.log(this.timingForm.timeStamp);
					const day = new Date(this.timingForm.timeStamp).getDate();
					const month = new Date(this.timingForm.timeStamp).getMonth() + 1;
					const year = new Date(this.timingForm.timeStamp).getFullYear();
					const hour = new Date(this.timingForm.timeStamp).getHours();
					const minute = new Date(this.timingForm.timeStamp).getMinutes();
					const second = new Date(this.timingForm.timeStamp).getSeconds();

					const data = {
						participant: this.selectedParticipantStore,
						version: 'v2',
						day,
						month,
						year,
						hour,
						minute,
						second
					};

					axios
						.post(process.env.VUE_APP_TIMETRAVEL_ENDPOINT, data, {
							headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
						})
						.then(res => {
							this.$notify({
								title: this.$t('success'),
								message: this.$t('success'),
								type: 'success'
							});

							const timetravelURL = `${process.env.VUE_APP_TIMETRAVEL_ENDPOINT}/${this.selectedParticipantStore}`;

							axios
								.get(timetravelURL, { headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` } })
								.then(res => {
									// this.$notify({
									// 	title: this.$t('success'),
									// 	message: this.$t('success'),
									// 	type: 'success'
									// });
									this.currentTime = new Date(res.data.now.value.toString());
								})
								.catch(e => {
									console.log(e);
								});
						})
						.catch(e => {
							console.log(e);
						});
				} else {
					this.$message('Fill in the date and time');
					return false;
				}
			});
		}
	}
};
</script>
<style lang="scss" scoped></style>
